// import "babel-polyfill"; /* importante per far funzionare tutto su IE e viene usato new URL da qualche parte */
import "core-js/stable";
import "regenerator-runtime/runtime";
// import "url-polyfill"; /* importante per far funzionare tutto su IE e viene usato new URL da qualche parte */
import React from "react";
// import ReactDOM from "react-dom";
import { createRoot } from "react-dom/client";
import { ThemeProvider } from "@ts-digital/vrc";
import RegistryProvider from "../src/contexts/RegistryContext";

import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/pro-solid-svg-icons";
import { far } from "@fortawesome/pro-regular-svg-icons";
import { fal } from "@fortawesome/pro-light-svg-icons";

import RoutesView from "./views";
import { HashRouter } from "react-router-dom";
import "antd/dist/antd.css";
import "./index.css";

import "moment/locale/es";
import "moment/locale/it";

console.warn = () => {};

library.add(
  fal, far, fas
);

const root = createRoot(document.getElementById("root"));
root.render(<HashRouter>
  <RegistryProvider>
    <ThemeProvider>
      <RoutesView />
    </ThemeProvider>
  </RegistryProvider>
</HashRouter>);

